import 'angular';
import './approval_files_panel.html';
import "./approvalResourceSelector/approvalResourceSelector"
import {RootScope} from "../../../types/angular-types";
import {ApprovalInfo, ApprovalResource} from '../../approvals-types';

interface IScope extends RootScope {
    // methods
    isResourcCurrent: (resource: ApprovalResource) => boolean;
    updateCurrentResource: (resource: ApprovalResource) => void;

    // properties
    approvalRequest: ApprovalInfo;
    currentResource: ApprovalResource;
}

angular.module('GorillaBoy.Approvals')
.directive('approvalFilesPanel', ['$log', ($log) => {
    return {
        restrict: 'E',
        scope: {
            approvalRequest: '=',
            currentResource: '=',
        },
        templateUrl: './approvals/approvalView/approvalFilesPanel/approval_files_panel.html',
        link: function($scope: IScope, $element, attrs) {
            

            
        }
    };
}]);